
export const FETCH_BILLS = 'FETCH_BILLS';
export const FETCH_BILLS_SUCCESS = 'FETCH_BILLS_SUCCESS';
export const FETCH_BILLS_FAILED = 'FETCH_BILLS_FAILED';
export const FETCH_BILL  = 'FETCH_BILL';
export const FETCH_BILL_SUCCESS = 'FETCH_BILL_SUCCESS';
export const FETCH_BILL_FAILED = 'FETCH_BILL_FAILED';
export const DELETE_BILL = 'DELETE_BILL';
export const CREATE_BILL = 'CREATE_BILL';
export const UPDATE_BILL = 'UPDATE_BILL';
export const UPDATE_BILL_SUCCESS = 'UPDATE_BILL_SUCCESS';
export const UPDATE_BILL_FAILED = 'UPDATE_BILL_FAILED';



// WEBPACK FOOTER //
// ./src/data/bills/types.js